const Wall = require("../../../lib/Wall")
const renderWall = require("./renderWall.js")

Wall.renderWall = renderWall
module.exports = Wall
